import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Mutation } from 'react-apollo';

import { AuthContext } from '../../../context';

import mutations from '../../../graphql/mutations';

import style from './index.module.scss';

const {
  answerMutations: { POST_ANSWER },
} = mutations;

class NewAnswerForm extends Component {
  static contextType = AuthContext;

  state = {
    answer: '',
    isAuthorAnonymous: false,
    shareOnTwitter: false,
  };

  onInit = editor => {
    console.log('Editor is ready to use!', editor);
  };

  onChange = (e, editor) => {
    const data = editor.getData();

    this.setState({
      answer: data,
    });
  };

  onCheck = social => {
    if (social === 'twitter') {
      this.setState({
        shareOnTwitter: !this.state.shareOnTwitter,
      });
    }
    if (!social) {
      this.setState({
        isAuthorAnonymous: !this.state.isAuthorAnonymous,
      });
    }
  };

  onAddAnswer = (e, postAnswer) => {
    e.preventDefault();

    const { answer, isAuthorAnonymous } = this.state;
    const { questionId } = this.props;
    const { currentUser } = this.context;

    if (answer && currentUser) {
      postAnswer({
        variables: {
          input: {
            body: answer,
            addedBy: currentUser.id,
            questionId,
            isAuthorAnonymous,
          },
        },
      });

      this.setState({
        answer: '',
        shareOnTwitter: false,
        shareOnFacebook: false,
      });
    } else {
      console.log('Something went wrong');
    }
  };

  render() {
    const { answer, shareOnTwitter, isAuthorAnonymous } = this.state;
    const { currentUser } = this.context;
    const {
      form,
      img,
      info,
      name,
      bio,
      submit,
      anonymous,
      button,
      share,
      label,
      checkbox,
      icon,
    } = style;

    return (
      <Mutation mutation={POST_ANSWER}>
        {postAnswer => (
          <form
            onSubmit={e => this.onAddAnswer(e, postAnswer)}
            className={`row ${form}`}
          >
            <div className={`col-12 ${style['col--user']}`}>
              <Link
                to={{
                  pathname: `/account/${currentUser.fullname}`,
                  state: {
                    userId: currentUser.id
                  }
                }}
              >
                <img
                  src={currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'}
                  alt={currentUser.fullname}
                  className={img}
                />
              </Link>
              <div className={info}>
                <p>
                  <Link 
                    to={{
                      pathname: `/account/${currentUser.fullname}`,
                      state: {
                        userId: currentUser.id
                      }
                    }}
                    className={name}
                  >
                    Collins Orlando
                  </Link>
                  ,{' '}
                  <span className={bio}>
                    I know a thing or two about maps
                  </span>
                </p>
                <p className={`text-muted ${style['edit-credential']}`}>
                  Edit credential
                </p>
              </div>
            </div>
            <div className={`col-12 ${style['col--input']}`}>
              <CKEditor
                editor={ClassicEditor}
                data={answer}
                onInit={this.onInit}
                onChange={this.onChange}
              />
            </div>
            <div className={`col ${style['col--actions']}`}>
              <div className={submit}>
                <button type='submit' className={`btn ${button}`}>
                  Submit
                </button>
                <span className={anonymous}>
                  <span className={label}>As Anonymous</span>
                  <input
                    type='checkbox'
                    name='isAuthorAnonymous'
                    value={isAuthorAnonymous}
                    onChange={() => this.onCheck()}
                    className={checkbox}
                  />
                </span>
              </div>
              <div className={share}>
                <span className={label}>Post to:</span>
                <input
                  type='checkbox'
                  name='shareOnTwitter'
                  value={shareOnTwitter}
                  onChange={() => this.onCheck('twitter')}
                  className={checkbox}
                />
                <span>
                  <i className={`fab fa-twitter ${icon}`} />
                </span>
              </div>
            </div>
          </form>
        )}
      </Mutation>
    );
  }
}

NewAnswerForm.propTypes = {
  questionId: PropTypes.string.isRequired,
};

export default NewAnswerForm;
